
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!gradebook.header_filter";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'gradebook/header-filter';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, self=this, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;

function program1(depth0,data) {
  
  
  return "id=\"lmgb-average-filter\"";
  }

  buffer += "<div class=\"inline-block\">\n  <a class=\"al-trigger\" href=\"#\" data-append-to-body=\"true\" role=\"button\" ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.inactive_concluded_lmgb_filters), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">\n    <span class=\"current-label\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("gradebook.header_filter")
  },data:data},helper ? helper.call(depth0, "course_average", "Course average", options) : helperMissing.call(depth0, "t", "course_average", "Course average", options)))
    + "</span>\n    <i class=\"icon-mini-arrow-down\"></i>\n  </a>\n\n  <ul class=\"al-options\">\n    <li><a href=\"#\" data-method=\"average\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("gradebook.header_filter")
  },data:data},helper ? helper.call(depth0, "course_average", "Course average", options) : helperMissing.call(depth0, "t", "course_average", "Course average", options)))
    + "</a></li>\n    <li><a href=\"#\" data-method=\"median\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("gradebook.header_filter")
  },data:data},helper ? helper.call(depth0, "course_median", "Course median", options) : helperMissing.call(depth0, "t", "course_median", "Course median", options)))
    + "</a></li>\n  </ul>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  